import axios from 'axios'

import { Channel } from 'modules/Monitoring/types'

export const getChannels = async () => {
  return (await axios.get<Channel[]>('/channels')).data
}
